define('taoQtiItem/qtiItem/core/interactions/InlineChoiceInteraction',['taoQtiItem/qtiItem/core/interactions/InlineInteraction'], function(InlineInteraction){
    var InlineChoiceInteraction = InlineInteraction.extend({
        'qtiClass' : 'inlineChoiceInteraction'
    });
    return InlineChoiceInteraction;
});


